import _ from 'lodash'
import uniqid from 'uniqid'
import Validator from 'validatorjs'
import events from '../Events'

export default {
    props: {
        note: {
            type: Object,
            required: true
        },
        readonly: false
    },
    data() {
        return {
            'defaults': {},
            'rules': {},
            'validation': null
        }
    },
    created() {
        _.each(this.defaults, (value, key) => {
            if (typeof this.note[key] === 'undefined') {
                this.note[key] = value
            }
        })

        if (typeof this.note['key'] === 'undefined') {
            this.note.key = uniqid()
        }

        this.validation = new Validator(this.note, {})
    },
    methods: {
        hasError(key) {
            return this.validation.errors.has(key);
        },
        errorState(key) {
            if (this.hasError(key)) {
                return "invalid";
            }
            return null;
        },
        error(key) {
            return this.validation.errors.first(key);
        },
        validate() {
            this.validation = new Validator(this.note, this.rules)
            return this.validation.passes()
        }
    }
}